export default function Button({ children, onClick, disabled, className = "" }) {
  return (
    <button 
      className={`btn ${className}`} 
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </button>
  );
}
